export default function reducer(state = {
  open: 'idle',
  z: 1,
  w: 0,
  h: 0,
  x: 0,
  y: 0,
}, action = {}) {
  switch (action.type) {
    case 'CALCULATE_CHAT':
      return {
        ...state,
        x: action.x,
        y: action.y,
        w: action.w,
        h: action.h,
        open: action.open,
      };
    case 'RECALCULATE_CHAT_ON_MOBILE':
      return {
        ...state,
        x: action.x,
        y: action.y,
        w: action.w,
        h: action.h,
      };
    case 'OPEN_CHAT':
      return {
        ...state,
        open: 'open',
        z: action.z,
      };
    case 'CLOSE_CHAT':
      return {
        ...state,
        open: 'idle',
      };
    case 'BRING_CHAT_TO_FRONT':
      return {
        ...state,
        z: action.z,
        open: 'open',
      };
    default:
      return state;
  }
}

export const calculateChat = (params) => {
  const { isMobile, windowHeight, windowWidth, landedSlug, mobileOrientation, } = params;
  if (isMobile) {
    return {
      type: 'CALCULATE_CHAT',
      x: 0,
      y: 0,
      w: mobileOrientation === 'landscape' ? windowWidth - 150 : windowWidth,
      h: mobileOrientation === 'landscape' ? windowHeight : windowHeight - 150,
      open: 'idle',
    };
  }
  const width = Math.max(windowWidth * 0.4, 500);
  const height = Math.max(width * 0.6, 300);
  const x = (windowWidth / 2) - (width / 2);
  const y = windowHeight - (Math.max(windowWidth * 0.047, 60)) - (Math.max(windowWidth * 0.02, 30)) - height - 15;
  return {
    type: 'CALCULATE_CHAT',
    x: 500,
    y: 270,
    w: width,
    h: height,
    open: (!landedSlug) ? 'open' : 'idle',
  };
};

export const recalculateChatOnMobile = (params) => {
  const { windowWidth, windowHeight, mobileOrientation, } = params;
  return {
    type: 'RECALCULATE_CHAT_ON_MOBILE',
    x: 0,
    y: 0,
    w: mobileOrientation === 'landscape' ? windowWidth - 150 : windowWidth,
    h: mobileOrientation === 'landscape' ? windowHeight : windowHeight - 150,
  };
};

export const openChat = (z) => {
  return {
    type: 'OPEN_CHAT',
    z,
  };
};

export const closeChat = (e) => {
  // stop propagation here to prevent handleBringToFront from getting called
  if (e && e.target) {
    e.stopPropagation();
  }
  return {
    type: 'CLOSE_CHAT',
  };
};

export const bringChatToFront = (z) => {
  return {
    type: 'BRING_CHAT_TO_FRONT',
    z,
  };
};
